import { Rule } from "antd/lib/form"
import { i18n } from "~Shared/locales/i18n"

export const createTransactionCategoryRules = () => ({
    name: [
        { required: true, message: i18n.t("validation:required") },
        { max: 128, message: i18n.t("validation:max.string", { max: 128 }) },
    ] as Array<Rule>,
})
